import Column from "@/Components/Grid/Column";
import Container from "@/Components/Grid/Container";
import Row from "@/Components/Grid/Row";
import { Head } from "@inertiajs/react";
import { puckConfiguration } from "@/Components/System/Editor/Editor";
import PatientLayout from "@/Layouts/PatientLayout";
import { ArticleModel } from "@/types/models/ArticleModel";
import { Render } from "@measured/puck";


const ArticleSingle = ({ article }: {
    article: ArticleModel
}) => {
    const newPath = article.hero
        ? `/patient${article.hero.replace('.' + article.hero.split('.').pop(), `.webp`)}/${article.id}/article`
        : '';

    // @ts-ignore
    const updatedComponents = JSON.parse(article.content ? article.content : '[]').map(component => {
        if (component.type === "Obraz") {
            const oldImagePath = component.props.image;
            const newPath = `${oldImagePath.replace('.' + oldImagePath.split('.').pop(), `.webp`)}/Article/${article.slug}`;
            return {
                ...component,
                props: {
                    ...component.props,
                    image: newPath
                }
            };
        }
        return component;
    });

    const initialData = {
        content: article ? updatedComponents : [],
        root: {
            title: article?.name,
        },
        zones: article ? JSON.parse(article.zones ? article.zones : '[]') : []
    };

    return (
        <PatientLayout>
            <Head title="Artykuły dla pacjenta" />

            <section id="hero-article" className='-mt-24 maxMd:-mt-20 relative min-h-screen mb-14 maxMd:mb-0'>
                <div className='object-cover bg-no-repeat bg-center bg-cover h-screen' style={{ backgroundImage: `url(${newPath})` }}>
                    <div className="absolute inset-0 w-full h-full bg-gradientArticle"></div>
                    <Container className='relative z-10 h-full'>
                        <Row className='items-center h-full'>
                            <Column className='h-full flex flex-col min-h-[calc(100vh_-_304px)]'>
                                <Row className="my-auto justify-center">
                                    <Column xl={10} className="text-center">
                                        <h1 className='h1 text-arcticMist font-semibold tracking-[1.2px] mb-2'>{article.name}</h1>
                                        <p className='mb-6 text-accordorange h4'>
                                            Czas czytania: {article.time} min
                                        </p>
                                    </Column>
                                </Row>
                            </Column>
                        </Row>
                    </Container>
                </div>
                <Container className="-mt-[8%] relative z-20 maxMd:mt-0">
                    <Row className="justify-center">
                        <Column xl={10}>
                            <div className="bg-gradientBackground py-28 maxMd:py-12 maxMd:-mx-4 max:max-w-[1920px] max:mx-auto">
                                <Container>
                                    <Row>
                                        <Column>
                                            <div className="px-4">
                                                {article.authors && article.authors.length > 0 &&
                                                    <div className="authors text-14 mb-12">
                                                        <p className="text-arcticMist">Autorzy:</p>
                                                        {article.authors.map((author, i) => (
                                                            <div key={i}>
                                                                <p className="text-accordorange">{author.degree} {author.name_surname} - {author.affiliation}</p>
                                                            </div>
                                                        ))}
                                                    </div>
                                                }
                                                <Render config={puckConfiguration} data={initialData} />
                                            </div>
                                        </Column>
                                    </Row>
                                </Container>
                            </div>
                        </Column>
                    </Row>
                </Container>
            </section>
        </PatientLayout>
    )
}

export default ArticleSingle;